(function($) {
  var viewport = document.documentElement.clientWidth

  $( window ).on('load', function() {
    if ($(document).scrollTop() > 125) {
      $('.header').addClass('headroom--not-top')
    }
  });
})( jQuery );

jQuery(document).ready(function ($) {
  var myElement = document.querySelector(".header");
  if (myElement) {
    var headroom  = new Headroom(myElement, {
      offset: $(myElement).outerHeight(),
      onPin : function() {
        var topBar = $('.topBar')
        var topBarHeight = topBar.outerHeight()
        var nav = $('.nav')

        if (topBar.length) {
          // var topBarHeight = Math.ceil(topBar.outerHeight())
          // topBar.css('transform', 'translateY(0)');
          // nav.css('transform', 'translateY(0)');
        }
      },
      onUnpin : function() {
        var topBar = $('.topBar')
        var nav = $('.nav')

        if (topBar.length) {
          // var topBarHeight = Math.ceil(topBar.outerHeight())
          // topBar.css('transform', 'translateY(-' + topBarHeight + 'px');
          // nav.css('transform', 'translateY(-' + topBarHeight + 'px');
        }
      },
    });

    headroom.init();
  }

  const el = document.querySelector(".header")
  if(el) {
    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1),
      { threshold: [1] }
    );

    observer.observe(el);
  }

  var viewport = document.documentElement.clientWidth

  $( 'a[href="#"]' ).click(
    function(e) {
      e.preventDefault()
    }
  );

  $('a.newTab, .newTab > a').each(function(index, el) {
    $(this).attr('target', '_blank');
  });

  $('.nav-menu').click(function(e) {
    e.preventDefault()
    $(this).toggleClass('active');
    $('.nav-right').toggleClass('active');
    $('body').toggleClass('u-noScroll');
  });

  $('.nav-sublinksToggle').click(function(e) {
    e.preventDefault()

    $(this).toggleClass('active')
    $(this).siblings('.sublinks').toggleClass('active')
  });

  var link = document.querySelector( ".skipNavigation-link" );

  if (link) {
    link.addEventListener(
      "focus",
      function() {
        link.parentElement.classList.add( "focus" );
      }
    );
    link.addEventListener(
      "blur",
      function() {
          link.parentElement.classList.remove( "focus" );
      }
    );
  }
});